<template>
  <section>
    <!-- Icono de carga -->
    <a href="#" v-tooltip="'Añadir Vehículo de Carga'"
      class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit" data-toggle="modal"
      :data-target="'#pedestrianToCargoModal' + selectedPerson.identification_number">
      <i class="la la-truck"></i>
    </a>
    <div class="modal fade" :id="`pedestrianToCargoModal${selectedPerson.identification_number}`" tabindex="-1"
      role="dialog" aria-labelledby="pedestrianToCargoLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ 'Vehículo de carga' | translate | capitalize }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form :data-vv-scope="`pedestrianToCargo${selectedPerson.identification_number}`">

            <div class="modal-body">
              <div class="form-group m-form__group">
                <div class="row">

                  <div class="col-md-6 m-form__group space-row-container">
                    <label
                      :class="{ 'm--font-danger': errors.has(`vehicle_type${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`) }">{{
                        'vehicle_type' | translate |
                        capitalize }}*</label>
                    <select :data-vv-as="`vehicle_type${selectedPerson.identification_number}`"
                      :data-vv-scope="`pedestrianToCargo${selectedPerson.identification_number}`"
                      :data-vv-name="`vehicle_type${selectedPerson.identification_number}`" class="form-control m-input"
                      v-model="cargo.vehicle_type_id" @change="updateCargoTypes(cargo.vehicle_type_id)"
                      v-validate="'required'" :id="`vehicle_type${selectedPerson.identification_number}`">
                      <option value="">{{ 'select_an_option' | translate | capitalize }}</option>
                      <option v-for="(cargo_vehicle, idx) in cargo_vehicle_type" :key="idx" :value="cargo_vehicle.id">
                        {{ cargo_vehicle.name | translate | capitalize }}
                      </option>
                    </select>
                    <span
                      v-show="errors.has(`vehicle_type${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`)"
                      class="m-form__help m--font-danger">
                      {{ translateErrorMessage('vehicle_type',
                        errors.first(`vehicle_type${selectedPerson.identification_number}`,
                          `pedestrianToCargo${selectedPerson.identification_number}`))
                      }}
                    </span>
                  </div>

                  <div class="col-md-6 m-form__group space-row-container">
                    <label
                      :class="{ 'm--font-danger': errors.has('cargo_type_vehicle_type' + selectedPerson.identification_number, `pedestrianToCargo${selectedPerson.identification_number}`) }">{{
                        'vehicle_type' | translate |
                        capitalize }}* </label>
                    <select :data-vv-as="`cargo_type_vehicle_type${selectedPerson.identification_number}`"
                      :data-vv-scope="`pedestrianToCargo${selectedPerson.identification_number}`"
                      :data-vv-name="`cargo_type_vehicle_type${selectedPerson.identification_number}`"
                      class="form-control m-input" v-model="cargo.cargo_vehicle_type" v-validate="'required'"
                      :id="`cargo_type_vehicle_type${selectedPerson.identification_number}`">
                      <option value="">{{ 'select_an_option' | translate | capitalize }}</option>
                      <option v-if="hideCargoType(cargo.vehicle_type_id, cargo_vehicle.type)"
                        v-for="(cargo_vehicle, idx) in cargo_type_vehicles" :key="idx" :value="cargo_vehicle.name">
                        {{ cargo_vehicle.name | translate | capitalize }}
                      </option>
                    </select>
                    <span
                      v-show="errors.has(`cargo_type_vehicle_type${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`)"
                      class="m-form__help m--font-danger">
                      {{
                        translateErrorMessage('cargo_type_vehicle_type',
                          errors.first(`cargo_type_vehicle_type${selectedPerson.identification_number}`,
                            `pedestrianToCargo${selectedPerson.identification_number}`))
                      }}
                    </span>
                  </div>

                  <div class="col-md-6 m-form__group space-row-container">
                    <label
                      :class="{ 'm--font-danger': errors.has(`truck_license_plate${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`) }">
                      {{ 'truck_license_plate' | translate | capitalize }}</label>
                    <input type="text" class="form-control m-input" v-model="cargo.truck_license_plate"
                      v-validate="'required|alpha_num|min:6|max:10'" data-vv-validate-on="input"
                      :data-vv-scope="`pedestrianToCargo${selectedPerson.identification_number}`"
                      :id="`truck_license_plate${selectedPerson.identification_number}`"
                      :data-vv-name="`truck_license_plate${selectedPerson.identification_number}`" />
                    <span v-show="errors.has(`truck_license_plate${selectedPerson.identification_number}`,
                      `pedestrianToCargo${selectedPerson.identification_number}`
                    )" class="m-form__help m--font-danger">
                      {{ translateErrorMessage('truck_license_plate',
                        errors.first(`truck_license_plate${selectedPerson.identification_number}`,
                          `pedestrianToCargo${selectedPerson.identification_number}`))
                      }}
                    </span>
                  </div>

                  <div class="col-md-6 m-form__group space-row-container">
                    <label :class="{
                      'm--font-danger': errors.has(`cargo_order${selectedPerson.identification_number}`,
                        `pedestrianToCargo${selectedPerson.identification_number}`
                      )
                    }">
                      {{ 'cargo_order' | translate | capitalize }}
                    </label>
                    <input type="text" class="form-control m-input" v-model="cargo.cargo_order"
                      v-validate="'required|alpha_num|min:1|max:20'" data-vv-validate-on="input"
                      :data-vv-scope="`pedestrianToCargo${selectedPerson.identification_number}`"
                      :id="`cargo_order${selectedPerson.identification_number}`"
                      :data-vv-name="`cargo_order${selectedPerson.identification_number}`" />
                    <span
                      v-show="errors.has(`cargo_order${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`)"
                      class="m-form__help m--font-danger">
                      {{ translateErrorMessage('cargo_order',
                        errors.first(`cargo_order${selectedPerson.identification_number}`,
                          `pedestrianToCargo${selectedPerson.identification_number}`)) }}
                    </span>
                  </div>

                  <div v-show="is_articulate" class="col-md-6 m-form__group space-row-container">
                    <label
                      :class="{ 'm--font-danger': errors.has(`trailer_license_plate${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`) }">
                      {{ 'trailer_license_plate' | translate | capitalize }}
                    </label>
                    <input type="text" class="form-control m-input" v-model="cargo.trailer_license_plate"
                      :required="is_articulate" v-validate="is_articulate ? 'required|alpha_num|min:6|max:10' : ''"
                      data-vv-validate-on="input" :id="`trailer_license_plate${selectedPerson.identification_number}`"
                      :data-vv-name="`trailer_license_plate${selectedPerson.identification_number}`"
                      :data-vv-scope="`pedestrianToCargo${selectedPerson.identification_number}`" />
                    <span
                      v-show="errors.has(`trailer_license_plate${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`)"
                      class="m-form__help m--font-danger">
                      {{ translateErrorMessage('trailer_license_plate',
                        errors.first(`trailer_license_plate${selectedPerson.identification_number}`,
                          `pedestrianToCargo${selectedPerson.identification_number}`)) }}
                    </span>
                  </div>

                  <div class="col-md-6 m-form__group space-row-container">
                    <label>{{ 'cargo_vehicle_model' | translate | capitalize }}</label>
                    <input type="text" class="form-control m-input" v-model="cargo.model" />
                  </div>
                  <div class="col-md-6 m-form__group space-row-container">
                    <label>{{ 'cargo_vehicle_brand' | translate | capitalize }}</label>
                    <input type="text" class="form-control m-input" v-model="cargo.brand" />
                  </div>
                  <div class="col-md-6 m-form__group space-row-container">
                    <label>{{ 'cargo_vehicle_color' | translate | capitalize }}</label>
                    <input type="text" class="form-control m-input" v-model="cargo.color" />
                  </div>
                  <div class="col-md-6 m-form__group space-row-container">
                    <label>{{ 'carrier_company' | translate | capitalize }}</label>
                    <input type="text" class="form-control m-input" v-model="cargo.carrier_company" />
                  </div>
                  <div class="col-md-6 m-form__group space-row-container">
                    <label>{{ 'container_number' | translate | capitalize }}</label>
                    <input type="text" class="form-control m-input" v-model="cargo.container_number" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary m-btn m-btn--icon" @click="handleSubmit">
                <span>{{ 'save' | translate | capitalize }}</span>
              </button>
              <button ref="closeModal" type="button" class="btn btn-primary m-btn m-btn--icon" @click="closeModal"
                data-dismiss="modal">
                <span>{{ 'close' | translate | capitalize }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swal from 'sweetalert2'
import { mapGetters, mapActions } from 'vuex'
export default {
  inject: ['$validator'],
  props: ['selectedPerson', 'cargo_vehicle_type', 'activeUser'],
  data() {
    return {
      identification_number: this.selectedPerson.identification_number,
      cargo: {
        vehicle_type_id: '',
        cargo_vehicle_type: '',
        truck_license_plate: '',
        cargo_order: '',
        trailer_license_plate: '',
        brand: '',
        model: '',
        color: '',
        carrier_company: '',
        container_number: ''
      },
      cargo_vehicle_type: this.cargo_vehicle_type,
      cargo_type_vehicles: [{ name: 'van', type: 'simple' }, { name: 'wagon', type: 'simple' }, { name: 'camion', type: 'simple' }, { name: 'truck', type: 'articulate' }, { name: 'mini_truck', type: 'articulate' }],
      is_articulate: true
    }

  },
  computed: {
    ...mapGetters({ idx_car: 'getIdxCar' }),
    filteredCargoTypes() {
      return this.cargo_type_vehicles.filter(type => type.id !== this.cargo.vehicle_type_id)
    }
  },
  methods: {
    ...mapActions(['setPedestrianToCargo']),
    changeToCargo() {
      this.setPedestrianToCargo({ authorization_id: this.authorization[idx].id, person_id: this.identification_number, vehicle_type_id: value })
        .then((res) => {
          if (res.status === 200) {
            this.authorization[idx].cargo_cars.vehicle_type_id = value
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    updateCargoTypes(idx) {
      const cargo = this.cargo_vehicle_type.find(cargo_vehicle => cargo_vehicle.id === idx && cargo_vehicle.name === 'articulate')

      cargo ? this.is_articulate = true : this.is_articulate = false

      this.cargo.cargo_vehicle_type = ''
      //validar los campos obligatorios
      this.$nextTick(() => {
        const scopeName = `pedestrianToCargo${this.selectedPerson.identification_number}`
        const scopeFields = this.$validator.fields.items.filter(field => field.scope === scopeName)
        this.$validator.validateAll(scopeName)
      });

    },
    hideCargoType(id, type) {
      let cargo_vehicle_type_act = this.cargo_vehicle_type.find(cvt => cvt.id === id)
      if (cargo_vehicle_type_act && cargo_vehicle_type_act.name === type) return true
      return false
    },
    handleSubmit() {
      //validar los campos que contenga el identificador de la persona
      const scope = `pedestrianToCargo${this.selectedPerson.identification_number}`

      const errors = this.$validator.errors.all(scope)
      console.log(errors);

      this.$validator.validateAll(scope).then((result) => {
        const errors = this.$validator.errors.all(scope)
        if (result) {
          this.saveCargo()
        } else {
          Swal.fire({
            type: 'warning',
            title: 'Complete los campos',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
          })
        }
      }).
        catch((err) => {
          console.log(err)
        })
    },
    saveCargo() {
      if (!this.identification_number) {
        return
      }

      const payload = {
        identification_number: this.identification_number,
        vehicle_type_id: this.cargo.vehicle_type_id,
        cargo_vehicle_type: this.cargo.cargo_vehicle_type,
        truck_license_plate: this.cargo.truck_license_plate,
        trailer_license_plate: this.cargo.trailer_license_plate,
        cargo_order: this.cargo.cargo_order,
        container_number: this.cargo.container_number,
        brand: this.cargo.brand,
        model: this.cargo.model,
        color: this.cargo.color,
        carrier_company: this.cargo.carrier_company,
      }

      this.$store.dispatch('setPedestrianToCargo', payload)
        .then(response => {

          if (response.data.success) {
            this.$emit('onSaveCargo', true)
            // Cierra el modal
            this.$refs.closeModal.click()
            // Toast de éxito
            this.$toast('transformed_to_load_correctly')
          } else {
            console.error('Error recibido del backend:', response.message)
          }
        })
        .catch(error => {
          console.error('Error en la solicitud al backend:', error)
        })
    },
    closeModal() {
      // Limpiar los campos
      // Elimina los errores de validación
      // console.log(this.$validator.errors.all(`pedestrianToCargo${this.selectedPerson.identification_number}`), 'antes de limpiar');
      this.$validator.errors.clear(`pedestrianToCargo${this.selectedPerson.identification_number}`);
      // console.log(this.$validator.errors.all(`pedestrianToCargo${this.selectedPerson.identification_number}`), 'después de limpiar');
      // Resetear la validación de los campos
      this.$validator.reset();
      this.cargo = {
        vehicle_type_id: '',
        cargo_vehicle_type: '',
        truck_license_plate: '',
        cargo_order: '',
        trailer_license_plate: '',
        brand: '',
        model: '',
        color: '',
        carrier_company: '',
        container_number: ''
      }

      setTimeout(() => {
        $('.modal-backdrop').remove()
        $('body').removeClass('modal-open')
      }, 300)

      this.$emit('close')
    },
    translateErrorMessage(key, errorMessage) {
      let message = ''
      if (errorMessage && !errorMessage.includes('cargo_type_vehicle_type')) {
        message = errorMessage.replace(key + this.identification_number, this.$options.filters.capitalize(key))
      } else if (errorMessage && errorMessage.includes('cargo_type_vehicle_type')) {
        message = errorMessage.replace("cargo_type_vehicle_type" + this.identification_number, this.$options.filters.capitalize("vehicle_type"))
      } else {
        message = errorMessage
      }

      return message
    }
  }
}
</script>

<style scoped>
.space-row-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-wrap: initial;
  margin-bottom: 15px;
}

.space-row-container label {
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 5px;
}

.form-group {
  margin-bottom: 15px;
}

.modal-body .row {
  display: flex;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.actions {
  text-align: right;
}

.actions>button {
  min-width: 140px;
}
</style>



// WEBPACK FOOTER //
// PedestrianToCargo.vue